import React, {useEffect, useState, useRef} from "react";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL, BACKEND_URL} from "../constants.js";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {Link} from "react-router-dom";

export function Status(props) {
    const from_date = useRef();
    const to_date = useRef();
    const report_status_id = useRef();
    const remarks = useRef();

    const [reportStatuses, setReportStatuses] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);

    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const generateReportHandler = (e) => {
        e.preventDefault();
        var queryString = '?from_date=' + from_date.current.value + '&to_date=' + to_date.current.value + '&report_status_id=' + selectedStatuses +'&remarks='+remarks.current.value;
        window.open(`${BACKEND_URL}status-summary${queryString}`);
    }

    useEffect(() => {
        axios.get(API_URL + 'report-status').then((response) => {
            if (response.data.status) {
                setReportStatuses(response.data.data);
            }
        });
    }, []);


    const statusClickHandler= (e)=>{
        if(e.target.checked){
            setSelectedStatuses([...selectedStatuses,e.target.value]);
        }
        else{
            let checkedStatuses = selectedStatuses.filter(status=> status!=e.target.value);
            setSelectedStatuses(checkedStatuses);
        }
    }

    //to test
    useEffect(() => {
        console.log(selectedStatuses);
    }, [selectedStatuses]);

    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title="Report Status Wise Summary">
                            <CardHeaderToolbar>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody>

                            <div className="mt-5">
                                <Form onSubmit={generateReportHandler}>
                                    <Form.Row>
                                        <Col md={5}>
                                            <Form.Label>From Date</Form.Label>
                                            <Form.Control type={'date'} ref={from_date} placeholder="Enter From Date"/>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Label>To Date</Form.Label>
                                            <Form.Control type={'date'} ref={to_date} placeholder="Enter To Date"/>
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>
                                        <Col md={5}>
                                            <Form.Label>Remarks</Form.Label>
                                            <Form.Control as={'textarea'} ref={remarks} placeholder="Enter remarks to be printed on report (Optional)"/>
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>
                                        <Col md={5}>
                                            <Form.Label>Select Statuses <small>(Leave Empty for All reporting)</small></Form.Label>
                                            <br/>
                                            {
                                                reportStatuses.map(status => (
                                                    <Form.Check
                                                        key={status.id}
                                                        type={'checkbox'}
                                                        id={`default`}
                                                        value={status.id}
                                                        onClick={(e)=>statusClickHandler(e)}
                                                        label={`${status.name}`}
                                                    />
                                                ))
                                            }
                                        </Col>
                                    </Form.Row>

                                    <hr/>

                                    <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                        Populate Report
                                        <span
                                            dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                    </Button>
                                </Form>

                            </div>

                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
}